/* KomfiNest — Footrest Height & Angle Calculator. Pure client-side geometry.
   Model: footrest = desk - 0.39*height ; chair seat = desk - 0.135*height
   (popliteal seat height ~0.255*H + seated elbow ~0.135*H). Estimate, not a measurement. */
(function(){
  var unit='in', goal='comfort', calculated=false, IN=2.54;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.querySelector('.kfc'); if(!root) return;
  function $(id){ return document.getElementById(id); }
  var hEl=$('kfc-h'), dEl=$('kfc-d'), adjEl=$('kfc-adj'), errEl=$('kfc-err'), resEl=$('kfc-result');

  function toCm(v){ return unit==='in' ? v*IN : v; }
  function fromCm(v){ return unit==='in' ? v/IN : v; }
  function fmt(vCm){ var v=fromCm(vCm); return unit==='in' ? (Math.round(v*10)/10)+'"' : Math.round(v)+' cm'; }

  document.querySelectorAll('.kfc-units button').forEach(function(b){
    b.addEventListener('click', function(){
      var nu=b.dataset.unit; if(nu===unit) return;
      [hEl,dEl].forEach(function(inp){ if(inp.value!==''){ var c=(unit==='in'?parseFloat(inp.value)*IN:parseFloat(inp.value)); inp.value = nu==='in' ? Math.round(c/IN*10)/10 : Math.round(c); } });
      unit=nu;
      document.querySelectorAll('.kfc-units button').forEach(function(x){ x.setAttribute('aria-pressed', x.dataset.unit===unit); });
      document.querySelectorAll('[data-unitlabel]').forEach(function(x){ x.textContent=unit; });
      if(unit==='in'){ hEl.min=40;hEl.max=90;hEl.step=.5;dEl.min=24;dEl.max=36;dEl.step=.5; }
      else { hEl.min=100;hEl.max=230;hEl.step=1;dEl.min=60;dEl.max=92;dEl.step=1; }
      $('kfc-std').textContent = unit==='in' ? 'Use standard 29 in' : 'Use standard 73 cm';
      if(calculated) compute();
    });
  });

  document.querySelectorAll('.kfc-seg button').forEach(function(b){
    b.addEventListener('click', function(){
      goal=b.dataset.goal;
      document.querySelectorAll('.kfc-seg button').forEach(function(x){ x.setAttribute('aria-pressed', x.dataset.goal===goal); });
      if(calculated) compute();
    });
  });

  $('kfc-std').addEventListener('click', function(){ dEl.value = unit==='in' ? 29 : 73; if(calculated) compute(); });
  adjEl.addEventListener('change', function(){ if(calculated) compute(); });
  [hEl,dEl].forEach(function(inp){ inp.addEventListener('input', function(){ if(calculated) compute(); }); });
  [hEl,dEl].forEach(function(inp){ inp.addEventListener('keydown', function(e){ if(e.key==='Enter') compute(); }); });

  function tween(from,to,dur,step,done){
    if(reduce){ step(to); if(done)done(); return; }
    var t0=null;
    function frame(ts){ if(!t0)t0=ts; var p=Math.min(1,(ts-t0)/dur); var e=1-Math.pow(1-p,3); step(from+(to-from)*e); if(p<1) requestAnimationFrame(frame); else if(done)done(); }
    requestAnimationFrame(frame);
  }

  function compute(){
    var h=parseFloat(hEl.value), d=parseFloat(dEl.value);
    errEl.textContent='';
    if(isNaN(h)||isNaN(d)){ errEl.textContent='Enter your height and your desk height.'; return; }
    var hCm=toCm(h), dCm=toCm(d);
    if(hCm<120||hCm>215){ errEl.textContent='That height looks off. Check your unit (inches vs cm).'; return; }
    if(dCm<58||dCm>95){ errEl.textContent='That desk height looks off. A standard desk is about 29 in / 73 cm.'; return; }

    var ELBOW=0.135, POPL=0.255;
    var seatCm=dCm-ELBOW*hCm, poplCm=POPL*hCm, footCm=Math.max(0,seatCm-poplCm), deskFlatCm=0.39*hCm;
    var needs=footCm>=2.5;

    resEl.hidden=false; requestAnimationFrame(function(){ resEl.classList.add('show'); });

    var v=$('kfc-verdict');
    if(needs){ v.className='kfc-verdict'; v.innerHTML='You need about a <b>'+fmt(footCm)+'</b> footrest.'; }
    else { v.className='kfc-verdict ok'; v.innerHTML='<b>Good news.</b> Your feet should reach the floor at this desk, so you likely do not need a footrest.'; }

    var tilt = goal==='swelling' ? '~30°' : '10-15°';
    countTo($('kfc-chair'), seatCm);
    if(needs){ countTo($('kfc-foot'), footCm); } else { $('kfc-foot').textContent='None'; }
    $('kfc-tilt').textContent = needs ? tilt : '--';
    drawRest(footCm, needs);

    var tip=$('kfc-tip');
    if(needs && adjEl.checked){ tip.hidden=false; tip.innerHTML='Since your desk adjusts: lowering it to about <strong>'+fmt(deskFlatCm)+'</strong> would let your feet reach the floor with no footrest at all. If you cannot go that low, the footrest above fills the rest.'; }
    else if(!needs && !adjEl.checked){ tip.hidden=false; tip.innerHTML='If your feet still do not feel flat, your chair may be set too high for the desk, so lower it slightly first, then re-check.'; }
    else { tip.hidden=true; }

    window.__kfcShare = needs
      ? 'My desk setup (KomfiNest calculator): chair seat '+fmt(seatCm)+', footrest '+fmt(footCm)+' at '+tilt+'. Desk '+fmt(dCm)+', height '+fmt(hCm)+'.'
      : 'My desk setup (KomfiNest calculator): chair seat '+fmt(seatCm)+', feet reach the floor (no footrest needed). Desk '+fmt(dCm)+', height '+fmt(hCm)+'.';
    calculated=true;
  }

  function countTo(el, vCm){ tweenText(el, parseDisplay(el.textContent), vCm); }
  function parseDisplay(t){ var m=(t||'').match(/[\d.]+/); if(!m) return 0; return toCm(parseFloat(m[0])); }
  function tweenText(el, fromCm, toCm2){ tween(fromCm, toCm2, 700, function(c){ el.textContent = fmt(Math.max(0,c)); }); }

  function drawRest(footCm, needs){
    var rect=$('kfc-restrect'), dim=$('kfc-dim'), dimline=$('kfc-dimline'), dimtop=$('kfc-dimtop'), dimtext=$('kfc-dimtext'), footg=$('kfc-footg');
    var floorY=196, maxPx=120, maxCm=18;
    var px = needs ? Math.max(12, Math.min(maxPx,(footCm/maxCm)*maxPx)) : 0;
    tween(parseFloat(rect.getAttribute('height'))||0, px, 750, function(p){
      rect.setAttribute('height', p); rect.setAttribute('y', floorY-p);
      footg.setAttribute('transform','translate(0,'+(34-p)+')');
      dimline.setAttribute('y2', floorY-p); dimtop.setAttribute('y1', floorY-p); dimtop.setAttribute('y2', floorY-p);
    }, function(){
      if(needs){ dim.setAttribute('opacity','1'); dimtext.textContent=fmt(footCm); dimtext.setAttribute('y',(floorY-px/2)+5); }
      else { dim.setAttribute('opacity','0'); }
    });
  }

  $('kfc-go').addEventListener('click', compute);
  $('kfc-copy').addEventListener('click', function(){
    var t=window.__kfcShare||'', btn=this;
    if(navigator.clipboard){ navigator.clipboard.writeText(t).then(function(){ btn.textContent='Copied ✓'; setTimeout(function(){ btn.textContent='Copy my setup'; },1800); }); }
    else { btn.textContent='Copied ✓'; }
  });
})();
